module.exports = __webpack_public_path__ + "a768e7de/img/link-icon.fa09ed66.svg";